import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import pl from './locales/pl.json';
import uk from './locales/uk.json';
import en from './locales/en.json';

export const LANGS = [
  { code: 'pl', label: 'Polski' },
  { code: 'uk', label: 'Українська' },
  { code: 'en', label: 'English' },
];

const STORAGE_KEY = 'lang';
export const DEFAULT_LANG = 'pl'; // польська за замовчуванням

const supported = LANGS.map((l) => l.code);
const stored = (typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY)) || '';
const initialLang = supported.includes(stored) ? stored : DEFAULT_LANG;

i18n.use(initReactI18next).init({
  resources: {
    pl: { translation: pl },
    uk: { translation: uk },
    en: { translation: en },
  },
  lng: initialLang,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: supported,
  interpolation: { escapeValue: false }, // React сам екранує
  returnEmptyString: false,
});

const applyHtmlLang = (lng) => {
  if (typeof document !== 'undefined') document.documentElement.setAttribute('lang', lng);
};
applyHtmlLang(i18n.language);

// Зберігати вибір мови й оновлювати <html lang>
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  try { localStorage.setItem(STORAGE_KEY, lng); } catch { /* ignore */ }
  applyHtmlLang(lng);
};

i18n.on('languageChanged', applyHtmlLang);

export default i18n;
